/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type UploadMetricsSecurity = {
  apikeyHeaderGramKey?: string | undefined;
  projectSlugHeaderGramProject?: string | undefined;
};

export type UploadMetricsRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  /**
   * Encoding applied to the OTLP request body. Supported values are gzip and identity.
   */
  contentEncoding?: string | undefined;
};

/** @internal */
export type UploadMetricsSecurity$Outbound = {
  "apikey_header_Gram-Key"?: string | undefined;
  "project_slug_header_Gram-Project"?: string | undefined;
};

/** @internal */
export const UploadMetricsSecurity$outboundSchema: z.ZodMiniType<
  UploadMetricsSecurity$Outbound,
  UploadMetricsSecurity
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.optional(z.string()),
    projectSlugHeaderGramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function uploadMetricsSecurityToJSON(
  uploadMetricsSecurity: UploadMetricsSecurity,
): string {
  return JSON.stringify(
    UploadMetricsSecurity$outboundSchema.parse(uploadMetricsSecurity),
  );
}

/** @internal */
export type UploadMetricsRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  "Content-Encoding"?: string | undefined;
};

/** @internal */
export const UploadMetricsRequest$outboundSchema: z.ZodMiniType<
  UploadMetricsRequest$Outbound,
  UploadMetricsRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    contentEncoding: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
      contentEncoding: "Content-Encoding",
    });
  }),
);

export function uploadMetricsRequestToJSON(
  uploadMetricsRequest: UploadMetricsRequest,
): string {
  return JSON.stringify(
    UploadMetricsRequest$outboundSchema.parse(uploadMetricsRequest),
  );
}
